<template>
  <div class="car-owner-wrap">
    <img src="../assets/img/owner-banner.png" alt="" class="big-img">
    <div class="form-wrap">
      <p class="title">车主招募</p>
      <div class="form-box">
        <div class="item">
          <p class="label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</p>
          <el-input class="input" maxLength="20" v-model="formInline.username" clearable></el-input>
        </div>
        <div class="item">
          <p class="label">手&nbsp;&nbsp;机&nbsp;&nbsp;号：</p>
          <el-input class="input" type="number" v-model="formInline.mobile" maxlength="11" @input="formInline.mobile = formInline.mobile.slice(0, 11)" clearable></el-input>
        </div>
        <div class="item">
          <p class="label">品牌型号：</p>
          <el-input class="input" maxLength="30" v-model="formInline.brand" clearable></el-input>
        </div>
        <div class="item">
          <p class="label">车&nbsp;&nbsp;架&nbsp;&nbsp;号：</p>
          <el-input class="input" maxLength="20" v-model="formInline.vin" clearable></el-input>
        </div>
        <div class="item">
          <p class="label">发动机号：</p>
          <el-input class="input" maxLength="20" v-model="formInline.carNo" clearable></el-input>
        </div>
        <div class="item">
          <p class="label">当前里程（km）：</p>
          <el-input class="input" v-model="formInline.mileage" type="number" @input="formInline.mileage = formInline.mileage.slice(0, 10)" clearable></el-input>
        </div>
        <div class="item">
          <p class="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</p>
          <el-input
            class="textarea-input"
            type="textarea"
            :rows="4"
            resize="none"
            maxLength="100"
            v-model="formInline.remark">
          </el-input>
        </div>
      </div>
      <div class="submit-btn-box">
        <el-button type="primary" class="submit-btn" :loading="btnLoading" @click="onSubmit">提交资料</el-button>
      </div>

      <!-- <div class="submit-btn" @click="onSubmit">提交资料</div> -->
    </div>
    <div class="pop-wrap" v-if="showPop">
      <div class="pop-main">
        <p class="title">提交资料成功</p>
        <p class="tips">已收到您的车辆信息，稍后会安排客服经理与您对接，请稍作等待！</p>
        <div class="btn" @click="showPop = false;">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        formInline: {
          username: '',
          mobile:'',
          brand:'',
          vin:'',
          carNo:'',
          mileage:'',
          remark:''
        },
        btnLoading: false,
        showPop: false
      }
    },
    methods: {
      onSubmit() {
        if(!this.formInline.username){
          return this.$message.error('请输入姓名');
        }
        // 校验手机号是否为11位数字
        if(!/^1[3456789]\d{9}$/.test(this.formInline.mobile)){
          return this.$message.error('请输入正确的手机号');
        }
        if(!this.formInline.brand){
          return this.$message.error('请输入品牌型号');
        }
        if(!this.formInline.vin){
          return this.$message.error('请输入发动机号');
        }
        if(!this.formInline.carNo){
          return this.$message.error('请输入车架号'); 
        }
        if(!this.formInline.mileage){
          return this.$message.error('请输入当前里程');
        }
        this.btnLoading = true;
        setTimeout(()=>{
          this.showPop = true;
          this.btnLoading = false;
        },500)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .car-owner-wrap{
    .big-img{
      display: block;
      width:100%;
    }
    .form-wrap{
      width: 920px;
      margin:0 auto;
      padding: 38px 0 130px;
      .title{
        text-align: center;
        font-size: 24px;
        color: #1b1b1b;
        font-weight: 600;
      }
      .form-box{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 50px;
        row-gap: 25px;
        .item{
          display: flex;
          align-items: center;
          &:nth-of-type(2n+1){
            .label{
              width: 90px;
            }
          }
          &:nth-last-of-type(1){
            width:100%;
          }
          .label{
            width: 150px;
            text-align: right;
            font-size: 18px;
            color: #1b1b1b;
          }
          .input{
            display: block;
            width: 300px;
            font-size: 18px;
            padding-left: 15px;
            box-sizing: border-box;
          }
          .textarea-input{
            flex:1;
            margin-left: 15px;
          }
        }
      }
      .submit-btn-box{
        text-align: center;
        .submit-btn{
          width: 240px;
          height: 60px;
          background-color: #5097ff;
          border-radius: 8px;
          margin: 70px auto 0;
          font-size: 18px;
          color: #ffffff;
        }
      }
      
    }
  }
  .pop-wrap{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .pop-main{
      width: 660px;
      background-color: #ffffff;
      border-radius: 8px;
      padding: 60px 90px;
      box-sizing: border-box;
      text-align: center;
      .title{
        font-size: 30px;
        color: #000000;
        line-height: 32px;
        font-weight: 600;
      }
      .tips{
        font-size: 20px;
        color: #0f1b20;
        line-height: 32px;
        margin: 35px 0;
      }
      .btn{
        width: 273px;
        height: 60px;
        background-color: #5097ff;
        border-radius: 8px;
        margin: 0 auto;
        line-height: 60px;
        color:#fff;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
</style>